<mat-table [dataSource]="taskExecutions">
  <ng-container matColumnDef="startDate">
    <mat-header-cell *matHeaderCellDef>start date</mat-header-cell>
    <mat-cell *matCellDef="let element">{{ element.startDate | date: 'yyyy-MM-dd HH:mm:ss' }}</mat-cell>
  </ng-container>

  <ng-container matColumnDef="name">
    <mat-header-cell *matHeaderCellDef>name</mat-header-cell>
    <mat-cell *matCellDef="let element">{{ getName(element) }}</mat-cell>
  </ng-container>

  <ng-container matColumnDef="description">
    <mat-header-cell *matHeaderCellDef>description</mat-header-cell>
    <mat-cell *matCellDef="let element">{{ formatDescription(element) }}</mat-cell>
  </ng-container>

  <ng-container matColumnDef="error">
    <mat-header-cell *matHeaderCellDef>error</mat-header-cell>
    <mat-cell *matCellDef="let element">{{ formatError(element) }}</mat-cell>
  </ng-container>

  <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
  <mat-row *matRowDef="let row; columns: displayedColumns" (click)="onRowClick(row)"></mat-row>
</mat-table>
